import {
  Box,
  FormControl,
  FormLabel,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  CookieCategory,
  CookieConsentPreferences,
  COOKIE_CATEGORIES,
} from "./CookieConsentTypes"

interface Props {
  preferences: CookieConsentPreferences
  onToggle: (category: CookieCategory, isEnabled: boolean) => void
}

const CookieConsentPreferencesPanel: React.FC<Props> = ({
  preferences,
  onToggle,
}) => {
  const { t } = useTranslation()

  return (
    <VStack spacing={4} align="stretch">
      {COOKIE_CATEGORIES.map(category => {
        const isNecessary = category === "necessary"
        const switchId = `p-cookie-consent-${category}-switch`

        return (
          <FormControl
            key={category}
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            gap={4}
          >
            <Box>
              <FormLabel htmlFor={switchId} mb={0} fontWeight="semibold">
                {t(
                  `components.cookie-consent.CookieConsentPreferencesPanel.${category}.title`
                )}
              </FormLabel>
              <Text fontSize="sm" color="gray.600">
                {t(
                  `components.cookie-consent.CookieConsentPreferencesPanel.${category}.description`
                )}
              </Text>
              {isNecessary && (
                <Text fontSize="xs" color="gray.500" mt={1}>
                  {t(
                    "components.cookie-consent.CookieConsentPreferencesPanel.alwaysActive"
                  )}
                </Text>
              )}
            </Box>
            <Switch
              id={switchId}
              data-testid={switchId}
              colorScheme="primary"
              isChecked={preferences[category]}
              isDisabled={isNecessary}
              onChange={event => onToggle(category, event.target.checked)}
              flexShrink={0}
              mt={1}
            />
          </FormControl>
        )
      })}
    </VStack>
  )
}

export default CookieConsentPreferencesPanel
